export default function OrcaLogo({ className = 'h-9 w-9', alt = 'Orca AI logo' }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ''}/orca-ai-logo.png`}
      alt={alt}
      className={`shrink-0 rounded-lg object-contain shadow-sm ring-1 ring-white/10 ${className}`}
    />
  );
}
